import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const CHARCOAL = "#111111";
const GOLD = "#C4A25D";
const GOLD_LIGHT = "#E8D5AA";
const WARM_WHITE = "#F5F0E8";

const LINKS = [
  { icon: FaLinkedin, label: "LinkedIn",  href: "https://www.linkedin.com/in/jimmontour" },
  { icon: FaInstagram, label: "Instagram", href: "https://www.instagram.com/jimmontour_/" },
  { icon: FaGithub,   label: "GitHub",    href: "https://github.com/jimmontour" },
  { icon: MdEmail,    label: "Email",     href: "mailto:jimmontour@gmail.com" },
];

const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1 } },
};
const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

export default function SocialLinksBar() {
  return (
    <Wrapper>
      <Inner>
        <Heading>Want to connect?</Heading>
        <Sub>
          I'm open to consulting work, PR conversations, and just saying hi.
        </Sub>
        <Links
          as={motion.div}
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {LINKS.map(({ icon: Icon, label, href }) => (
            <SocialLink
              key={label}
              href={href}
              target={href.startsWith("mailto") ? undefined : "_blank"}
              rel="noopener noreferrer"
              as={motion.a}
              variants={fadeUp}
            >
              <Icon />
              <span>{label}</span>
            </SocialLink>
          ))}
        </Links>
      </Inner>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  background: ${CHARCOAL};
  padding: 4rem 2rem;
  width: 100%;
`;

const Inner = styled.div`
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const Heading = styled.h2`
  font-family: 'DM Serif Display', Georgia, serif;
  font-weight: 400;
  font-size: clamp(1.75rem, 3.5vw, 2.5rem);
  color: ${WARM_WHITE};
  margin: 0;
  letter-spacing: -0.02em;
`;

const Sub = styled.p`
  font-size: 0.9375rem;
  color: #9E9E8E;
  margin: 0;
  line-height: 1.65;
`;

const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
  margin-top: 0.75rem;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 1.25rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #9E9E8E;
  font-family: 'Inter', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;

  svg { font-size: 1rem; }

  &:hover {
    background: ${GOLD};
    border-color: ${GOLD};
    color: ${CHARCOAL};
    transform: translateY(-2px);
  }
`;
